import React, { FC, useEffect, useRef, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { renderFilArianne, renderTitleH1 } from './RenderCommon';
import { initEvent } from '../../utils';
import FormAddressApp from '../form-address/FormAddressApp';
import { AddressType, BaseForm, FormAddressRef, ProForm } from '../form-address/fa-interfaces';
import { addAddress, updateAddress } from '../../service/address.api';

type Props = RouteComponentProps<{id?: string;}>;

const RenderAddressForm: FC<Props> = ({ match }): JSX.Element => {
  const [addressType, setAddressType] = useState<AddressType>('shipping');
  const [addressState, setAddressState] = useState<BaseForm |(BaseForm & ProForm)|undefined>(undefined);
  const [alert, setAlert] = useState<{ text: string; type: 'success' | 'danger'; } | undefined>(undefined);

  const refForm = useRef<FormAddressRef>(null);

  useEffect(() => {
    document.dispatchEvent(initEvent('dp-loading'));
  }, []);

  useEffect(() => {
    if (alert) {
      setTimeout(() => setAlert(undefined), 5000);
    }
  }, [alert])

  const defineTitle = (): string => {
    let title = 'Ajouter une adresse de livraison';
    if (addressState?.id && addressType === 'billing') {
      title = 'Modifier mon adresse de facturation';
    } else if (addressState?.id && addressType === 'shipping') {
      title = 'Modifier mon adresse de livraison';
    } else if (addressState?.id) {
      title = 'Modifier mon adresse';
    } else if (addressType === 'billing') {
      title = 'Ajouter une adresse de facturation';
    }
    return title;
  };

  const defineTextValidateButton = (): string => {
    let text = 'Ajouter mon adresse';
    if (addressState?.id && addressType === 'billing') {
      text = 'Mettre à jour mon adresse de facturation';
    } else if (addressState?.id && addressType === 'shipping') {
      text = 'Mettre à jour mon adresse de livraison';
    } else if (addressState?.id) {
      text = 'Mettre à jour mon adresse';
    }
    return text;
  };

  const handleFormLoad = (): void => {
    document.dispatchEvent(initEvent('dp-loaded'));
    if (refForm.current) {
      const state = refForm.current.getState();
      setAddressState(state);
      setAddressType(state.is_facturation === 1 ? 'billing' : 'shipping');
    }
  };

  const handleSubmit = async (): Promise<void> => {
    if (refForm.current && await refForm.current.formIsValid()) {
      document.dispatchEvent(initEvent('dp-loading'));
      const form = refForm.current.getState();
      if (match.params.id) {
        updateAddress(parseInt(match.params.id), form)
          .then(() => setAlert({ text: 'Votre adresse a bien été mise à jour !', type: 'success' }))
          .catch((error) => setAlert({ text: error.message, type: 'danger' }))
          .finally(() => document.dispatchEvent(initEvent('dp-loaded')));
      } else {
        addAddress(form)
          .then(() => setAlert({ text: 'Votre adresse a bien été créée !', type: 'success' }))
          .catch((error) => setAlert({ text: error.message, type: 'danger' }))
          .finally(() => document.dispatchEvent(initEvent('dp-loaded')));
      }
    }
  };

  const types: { type: AddressType; label: string; }[] = [
    { type: 'shipping', label: 'livraison' },
    { type: 'billing', label: 'facturation'}
  ];

  return (
    <div>
      <div>
        {renderTitleH1('carnet', defineTitle())}
      </div>
      {renderFilArianne(<Link className="grey" to="/addresses">Mon carnet d'adresses</Link>, defineTitle())}
      <div className="mx-auto mt-5" style={{ width: 'fit-content' }}>
        {match.params.id === undefined && (
          <div className="d-flex">
            {types.map(({ type, label }) => (
              <button
                key={type}
                className={`border reset-button buttonPrimary rounded-lg mr-3 p-3 ${addressType === type ? 'bg-black white' : ''}`}
                onClick={() => setAddressType(type)}
              >
                Adresse de {label}
              </button>
            ))}
          </div>
        )}
        <div className="formProfil large border p-3 rounded-lg">
          <FormAddressApp
            ref={refForm}
            addressId={match.params.id ? parseInt(match.params.id) : undefined}
            type={addressType}
            disabledCheckboxShipping
            showFavoriteCheckbox
            onLoad={handleFormLoad}
          />
          {alert && (
            <div className={`d-flex alert my-3 font-14 alert-${alert.type}`} role="alert">
            {alert.text}
          </div>
          )}
          <button className="profilButton border-0 py-1 px-3 reset-button buttonPrimary bg-blue white mt-5" onClick={handleSubmit}>
            {defineTextValidateButton()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenderAddressForm;
